import React from 'react'

const BasicCard = ({children, className}) => {
  return (
    <div
      className={`rounded border p-5 lg:p-8 ${className}`}
      style={{borderColor: '#eee'}}
    >
      {children}
    </div>
  )
}

export { BasicCard }